"use client";
import React, { useEffect, useState, useMemo } from "react";
import { Box, Button, Typography, IconButton, TextField } from "@mui/material";
import Tables from "./widgets/tables";
import { Column } from "primereact/column";
import { useDispatch, useSelector } from "react-redux";
import LazyTable from "./widgets/lazytable";

const OnlineCustomers = () => {
  const user = useSelector((v) => v?.onlines?.active);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          my: 4,
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h5">All Active Customers</Typography>
      </Box>
      <LazyTable
        data={[]}
        page={0}
        rowsPerPage={0}
        totalRecords={0}
        loading={false}
        onPageChange={() => {}}
        onRowsPerPageChange={() => {}}
        onFilterChange={(filters) => {}}
        columns={[
          { field: "name", headerName: "Name", filter: true },
          {
            field: "balance",
            headerName: "Wallet Balance",
            filter: true,
          },
          {
            field: "role",
            headerName: "Role",
            filter: true,
          },
          {
            field: "query",
            headerName: "IP Address",
            filter: true,
          },
          {
            field: "country",
            headerName: "Country",
            filter: true,
          },
          {
            field: "lat",
            headerName: "Marker",
            filter: true,
          },
          {
            field: "timezone",
            headerName: "Time Zone",
          },
        ]}
      />
    </>
  );
};

export default OnlineCustomers;
